import cn from 'classnames'
import React, { forwardRef } from 'react'

import styles from './MenuListLabel.module.scss'

import { useMenuContext } from '~lib/ui-kit/MenuLayout'
import Checkbox from '~shared/ui/Checkbox'

export type MenuListLabelProps = React.HTMLAttributes<HTMLDivElement> & {
  active?: boolean
  selected?: boolean
  disabled?: boolean
  icon?: React.ReactNode
  endIcon?: React.ReactNode
  children?: React.ReactNode
  variant?: 'accent' | 'primary' | 'secondary'
  type?: 'button' | 'checkbox'
  labelClassName?: string
}

function MenuListLabel(
  {
    active,
    selected,
    disabled,
    variant: labelVariant = 'secondary',
    type = 'button',
    icon,
    endIcon,
    className = '',
    children,
    onChange,
    labelClassName,
    ...props
  }: MenuListLabelProps,
  ref: React.Ref<HTMLDivElement>
) {
  const { variant: menuVariant } = useMenuContext()

  return (
    <div
      className={cn(
        styles.root,
        styles[labelVariant],
        styles[menuVariant],
        active && styles.active,
        selected && styles.selected,
        disabled && styles.disabled,
        className
      )}
      ref={ref}
      role="menuitem"
      tabIndex={disabled ? -1 : 0}
      data-disabled={disabled}
      {...props}
    >
      {type === 'checkbox' && <Checkbox checked={!!selected} className={styles.checkbox} onChange={onChange} />}
      {icon && <span className={cn(styles.icon, styles.before)}>{icon}</span>}
      <span className={cn(styles.label, labelClassName)}>{children}</span>
      {endIcon && <span className={cn(styles.icon)}>{endIcon}</span>}
    </div>
  )
}

export default forwardRef(MenuListLabel)
